import { z } from 'zod';
const usageSchema = z.object({
    inputTokens: z.number(),
    outputTokens: z.number(),
    cachedInputTokens: z.number().optional(),
});
/** The fields a trace event must carry; the rest pass through as the hook wrote them. */
const traceEventSchema = z
    .object({
    type: z.string(),
    agentId: z.string(),
    timestamp: z.number(),
    runId: z.string().optional(),
    nodeId: z.string().optional(),
    parentNodeId: z.string().optional(),
    usage: usageSchema.optional(),
    prompt: z
        .object({ system: z.string(), messages: z.array(z.unknown()), tools: z.array(z.string()) })
        .optional(),
    artifact: z.object({ kind: z.string(), key: z.string(), name: z.string() }).optional(),
})
    .loose();
/**
 * Feeds a run's trace into the run store: the `data-dev-trace` parts the engine's trace hook writes,
 * one per step with its inputs and outputs, which the debug panel draws as a waterfall. A part that
 * does not parse is dropped rather than drawn wrong.
 */
export const traceExtension = {
    part: 'data-dev-trace',
    onPart: (data, { store }) => {
        const parsed = traceEventSchema.safeParse(data);
        if (parsed.success)
            store.getState().addTraceEvent(parsed.data);
    },
};
